import React from 'react'

import LinkButton from './LinkButton'
import * as routes from '../../../constants/routes'

const BackHomeButton = (props) =>
    <LinkButton to={routes.HOME} type="danger" className="cancel-button">{props.children}</LinkButton>

export default BackHomeButton